export const KEYWORD_GAP_COLUMNS = {
    SEARCH_INTENT: 'searchIntent',
    CONTENT_TYPE: 'contentType',
    SERP_FEATURES: 'serpFeatures',
    KW_OPPORTUNITIES: 'kwOpps',
    MSV_TRENDS: 'msvTrends',
    AVG_SEARCH_VOLUME: 'avgSearchVolume',
    // SERP_POSITION: 'serpPosition',
    CPC: 'cpc',
    PPC: 'ppc',
    KEYWORD_DIFFICULTY: 'keywordDifficulty',
};

export const KEYWORD_COLUMNS = {
    CONTENT_TYPE: 'CONTENT_TYPE',
    SEARCH_INTENT: 'SEARCH_INTENT',
    SERP_FEATURES: 'SERP_FEATURES',
    KW_OPPORTUNITIES: 'KW_OPPORTUNITIES',
    AVG_SEARCH_VOLUME: 'AVG_SEARCH_VOLUME',
    TREND: 'TREND',
    CPC: 'CPC',
    PPC: 'PPC',
    EV: 'EV',
    POS: 'POS',
    KEYWORD_DIFFICULTY: 'KEYWORD_DIFFICULTY',
};

export const SEARCH_BY_KEYWORD_COLUMNS = [
    KEYWORD_COLUMNS.SEARCH_INTENT,
    KEYWORD_COLUMNS.CONTENT_TYPE,
    KEYWORD_COLUMNS.SERP_FEATURES,
    KEYWORD_COLUMNS.KW_OPPORTUNITIES,
    KEYWORD_COLUMNS.TREND,
    KEYWORD_COLUMNS.AVG_SEARCH_VOLUME,
    KEYWORD_COLUMNS.CPC,
    KEYWORD_COLUMNS.PPC,
    KEYWORD_COLUMNS.KEYWORD_DIFFICULTY,
];

export const SEARCH_BY_DOMAIN_COLUMNS = [
    KEYWORD_COLUMNS.SEARCH_INTENT,
    KEYWORD_COLUMNS.CONTENT_TYPE,
    KEYWORD_COLUMNS.SERP_FEATURES,
    KEYWORD_COLUMNS.KW_OPPORTUNITIES,
    KEYWORD_COLUMNS.POS,
    KEYWORD_COLUMNS.TREND,
    KEYWORD_COLUMNS.AVG_SEARCH_VOLUME,
    KEYWORD_COLUMNS.EV,
    KEYWORD_COLUMNS.CPC,
    KEYWORD_COLUMNS.PPC,
    KEYWORD_COLUMNS.KEYWORD_DIFFICULTY,
];

export const KEYWORD_COLUMNS_MAP = {
    [KEYWORD_COLUMNS.CONTENT_TYPE]: 'SERP content types (SC)',
    [KEYWORD_COLUMNS.SEARCH_INTENT]: 'Search intents',
    [KEYWORD_COLUMNS.SERP_FEATURES]: 'SERP Features (SF)',
    [KEYWORD_COLUMNS.KW_OPPORTUNITIES]: 'Keyword opportunities',
    [KEYWORD_COLUMNS.AVG_SEARCH_VOLUME]: 'Avg. search volume (Search)',
    [KEYWORD_COLUMNS.EV]: 'Estimated visits',
    [KEYWORD_COLUMNS.POS]: 'Position',
    [KEYWORD_COLUMNS.TREND]: 'Search Volume Trend (Trend)',
    [KEYWORD_COLUMNS.CPC]: 'Cost Per Click (CPC)',
    [KEYWORD_COLUMNS.PPC]: 'PPC Competition (PPC)',
    [KEYWORD_COLUMNS.KEYWORD_DIFFICULTY]: 'Keyword difficulty (KD)',
};

export const KEYWORD_GAP_COLUMNS_MAP = {
    [KEYWORD_GAP_COLUMNS.CONTENT_TYPE]: 'SERP content types (SC)',
    [KEYWORD_GAP_COLUMNS.SEARCH_INTENT]: 'Search intents',
    [KEYWORD_GAP_COLUMNS.SERP_FEATURES]: 'SERP Features (SF)',
    [KEYWORD_GAP_COLUMNS.KW_OPPORTUNITIES]: 'Keyword opportunities',
    [KEYWORD_GAP_COLUMNS.AVG_SEARCH_VOLUME]: 'Avg. search volume (Search)',
    // [KEYWORD_GAP_COLUMNS.SERP_POSITION]: 'Position',
    [KEYWORD_GAP_COLUMNS.MSV_TRENDS]: 'Search Volume Trend (Trend)',
    [KEYWORD_GAP_COLUMNS.CPC]: 'Cost Per Click (CPC)',
    [KEYWORD_GAP_COLUMNS.PPC]: 'PPC Competition (PPC)',
    [KEYWORD_GAP_COLUMNS.KEYWORD_DIFFICULTY]: 'Keyword difficulty (KD)',
};

// rank is KD :) GJ with naming guys
export const COMPETITOR_SORTABLE_COLUMNS_ONLY_ON_FE = ['rank', 'msvTrends'];
